/* Mia custom cart: timer, segmented tier rewards (by item count), upsell carousel, remove, checkout total */
(function () {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var TIERS = [
    { count: 2, before: 'You are {COUNT} away from getting a 15% discount.' },
    { count: 3, before: 'You need {COUNT} more to get a 20% discount.' },
    { count: 4, before: 'You need {COUNT} more to get a 25% discount.' }
  ];
  var AFTER = 'Congratulations, free shipping is unlocked!';
  var TIMER_SECONDS = 600;
  var HIDDEN_HANDLES = ['shipping-protection'];
  var CUR = (drawer.getAttribute('data-currency') || '') + ' ';

  function money(cents) {
    var m = (window.theme && theme.Currency && theme.Currency.formatMoney)
      ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat)
      : '$' + (cents / 100).toFixed(2);
    return CUR + m;
  }

  /* Timer: "Your cart is reserved for 10:00" */
  var timerEl = drawer.querySelector('[data-mia-timer]');
  function timerStart() {
    var start;
    try { start = parseInt(sessionStorage.getItem('miaCartTimer'), 10); } catch (e) {}
    if (!start || Date.now() - start > TIMER_SECONDS * 1000) {
      start = Date.now();
      try { sessionStorage.setItem('miaCartTimer', String(start)); } catch (e) {}
    }
    return start;
  }
  function tick() {
    if (!timerEl) return;
    var left = Math.max(0, TIMER_SECONDS - Math.floor((Date.now() - timerStart()) / 1000));
    var m = Math.floor(left / 60), s = left % 60;
    timerEl.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }
  tick();
  setInterval(tick, 1000);

  function render(cart) {
    var count = 0;
    cart.items.forEach(function (i) { if (HIDDEN_HANDLES.indexOf(i.handle) === -1) count += i.quantity; });

    var countEl = drawer.querySelector('[data-mia-count]');
    if (countEl) countEl.textContent = count;
    var totalEl = drawer.querySelector('[data-mia-total]');
    if (totalEl) totalEl.textContent = money(cart.total_price);

    /* Segmented bar: segment i fills from previous tier count to tier i count */
    var rewards = drawer.querySelector('[data-mia-rewards]');
    if (rewards) {
      rewards.hidden = count === 0;
      var next = null, prev = 0;
      TIERS.forEach(function (t, i) {
        var seg = drawer.querySelector('[data-mia-seg="' + i + '"]');
        var pct = count >= t.count ? 100 : (count <= prev ? 0 : ((count - prev) / (t.count - prev)) * 100);
        if (seg) seg.style.width = pct + '%';
        if (!next && count < t.count) next = t;
        prev = t.count;
      });
      drawer.querySelector('[data-mia-rewards-text]').textContent = next ? next.before.replace('{COUNT}', next.count - count) : AFTER;
      drawer.querySelectorAll('[data-mia-tier]').forEach(function (el) {
        el.classList.toggle('is-complete', count >= parseInt(el.getAttribute('data-mia-tier'), 10));
      });
    }

    var inCart = cart.items.map(function (i) { return String(i.product_id); });
    var shown = 0;
    drawer.querySelectorAll('.mia-cart__upsell').forEach(function (el) {
      var hide = inCart.indexOf(el.getAttribute('data-product-id')) !== -1;
      el.hidden = hide;
      if (!hide) shown++;
    });
    var ups = drawer.querySelector('[data-mia-upsells]');
    if (ups) ups.hidden = shown === 0 || count === 0;
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function rebuild() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    refresh();
  }

  /* Impulse replaces [data-products] on every change */
  var products = drawer.querySelector('[data-products]');
  if (products && window.MutationObserver) {
    var pending;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(refresh, 50);
    }).observe(products, { childList: true });
  }
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) render(e.detail.cart); else refresh();
  });
  document.addEventListener('ajaxProduct:added', refresh);

  drawer.addEventListener('change', function (e) {
    if (!e.target.classList.contains('mia-cart__upsell-variant')) return;
    e.target.closest('.mia-cart__upsell').querySelector('.mia-cart__upsell-add').setAttribute('data-variant-id', e.target.value);
  });

  drawer.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-mia-arrow]');
    if (arrow) {
      e.preventDefault();
      var row = drawer.querySelector('[data-mia-row]');
      row.scrollBy({ left: row.clientWidth * parseInt(arrow.getAttribute('data-mia-arrow'), 10), behavior: 'smooth' });
      return;
    }

    var rm = e.target.closest('[data-mia-remove]');
    if (rm) {
      e.preventDefault();
      rm.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: rm.getAttribute('data-mia-remove'), quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var form = drawer.querySelector('#CartDrawerForm');
          if (form) form.parentNode.classList.toggle('is-empty', cart.item_count === 0);
          rebuild();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        })
        .catch(function () { rm.disabled = false; });
      return;
    }

    var btn = e.target.closest('.mia-cart__upsell-add');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { btn.disabled = false; rebuild(); })
      .catch(function () { btn.disabled = false; });
  });

  refresh();
})();
